// extracted by mini-css-extract-plugin
export default {"ProductCarouselItem":"ProductCarouselItem__ProductCarouselItem___X3nGH","unloadedImage":"ProductCarouselItem__unloadedImage___Zy1YZ"};